import {ConfigObjectType, locationContainer} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import * as React from 'react';
import {useEffect} from 'react';
import {connect, ConnectedProps} from 'react-redux';

import {MuiFilterBox} from './MuiFilterBox';
import {getNotEmptySelectedFilters} from '../filtering_selectors';
import {
  getCaseType,
  getServiceUrls,
} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {
  saveUserFilter,
  loadFiltersConfig,
  loadStateFromParams,
  loadStateFromParamsWithDefaultValues,
} from 'src/js/containers/filtering/filtering_actions';
import {RootState} from 'src/js/store';

interface OwnProps {
  config: ConfigObjectType;
  filteringStateId: string;
  filterAndSearchStateId: string;
  serviceUrls: Record<string, any>;
  featureName?: string;
}

const mapState = (state: RootState, props: OwnProps) => ({
  filtersConfig: state[props.filteringStateId].filtersConfig,
  locationState: state[props.filteringStateId].locationState,
  schema: state[props.filteringStateId].schema,
  caseType: getCaseType(state, props),
  selectedFilters: getNotEmptySelectedFilters(state, props),
  serviceUrlsBySelector: getServiceUrls(state, props),
});

const mapDispatch = {
  changeParams: locationContainer.changeParams,
  loadFiltersConfigAC: loadFiltersConfig,
  loadStateFromParamsAC: loadStateFromParams,
  loadStateFromParamsWithDefaultValuesAC: loadStateFromParamsWithDefaultValues,
  saveUserFilterAC: saveUserFilter,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const MUIFilteringContainerComponent: React.FC<Props> = (props) => {
  const {
    config,
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    serviceUrlsBySelector,
    caseType,
    schema,
    selectedFilters,
    locationState,
    loadFiltersConfigAC,
    loadStateFromParamsAC,
    loadStateFromParamsWithDefaultValuesAC,
    saveUserFilterAC,
    featureName,
  } = props;

  useEffect(() => {
    if (isEmpty(filtersConfig) || !filtersConfig.isLoaded()) {
      // TODO-JK: refactor configContainer is removed
      loadFiltersConfigAC(
        filteringStateId,
        serviceUrlsBySelector.filtersConfigPath,
        'CONFIG_STATE_ID',
        config.service.url.range,
        config.service.url.configDataSet,
        config.service.url.userFilters,
        serviceUrlsBySelector.userFilterType,
        filterAndSearchStateId
      );
    } else {
      loadStateFromParamsWithDefaultValuesAC(
        filteringStateId,
        filterAndSearchStateId,
        serviceUrlsBySelector.userFilterType,
        featureName
      );
    }
  }, [
    config.service.url.configDataSet,
    config.service.url.range,
    config.service.url.userFilters,
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    loadFiltersConfigAC,
    loadStateFromParamsWithDefaultValuesAC,
    featureName,
    serviceUrlsBySelector.filtersConfigPath,
    serviceUrlsBySelector.userFilterType,
  ]);

  useEffect(() => {
    if (locationState.reload) {
      if (filtersConfig.isLoaded()) {
        // we have to load default values if we access filtering container through formatter link
        loadStateFromParamsWithDefaultValuesAC(
          filteringStateId,
          filterAndSearchStateId,
          serviceUrlsBySelector.userFilterType,
          featureName
        );
      } else {
        loadStateFromParamsAC(
          filteringStateId,
          filterAndSearchStateId,
          featureName
        );
      }
    }
  }, [
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    loadStateFromParamsAC,
    loadStateFromParamsWithDefaultValuesAC,
    locationState.reload,
    featureName,
    serviceUrlsBySelector.userFilterType,
  ]);

  const saveFilter = (filterName: any) => {
    saveUserFilterAC(
      filteringStateId,
      config.service.url.userFilters,
      serviceUrlsBySelector.userFilterType,
      filterName
    );
  };

  return (
    <MuiFilterBox
      caseType={caseType}
      config={config}
      filteringStateId={filteringStateId}
      filterAndSearchStateId={filterAndSearchStateId}
      saveFilter={saveFilter}
      selectedFilters={selectedFilters}
      schema={schema}
      serviceUrls={serviceUrlsBySelector}
    />
  );
};

MUIFilteringContainerComponent.displayName = 'MuiFilteringContainer';

export const MuiFilteringContainer = connector(MUIFilteringContainerComponent);
